import { Chip } from '@mui/material';

interface EquipmentChipProps {
  value: string | undefined;
}

const EquipmentChip = ({ value }: EquipmentChipProps) => {
  if (typeof value !== 'string' || value === '') {
    return null;
  }

  return <Chip label={value} size="small" sx={{ maxWidth: '100%' }} />;
};

export default EquipmentChip;
